import { render } from "./TaskEdit.vue?vue&type=template&id=7f2629e3"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__